module.exports = __webpack_public_path__ + "static/media/fileIcon.d03b3619.svg";